import { Injectable } from "@angular/core";
import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";
import { environment } from "src/environments/environment";
import { SecurityService } from 'src/app/services';


@Injectable({ providedIn: "root" })
export class InactivityService {

  timedOut = false;
  lastPing: Date | null = null;
  typeStarted: Date | null = null;
  started = false;

  constructor
    (
      private idle: Idle,
      private securityService: SecurityService
    ) {
  }


  setIdleSessionTimeOut() {


    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // if the user is idle , redirect the user to login again ( session time out )

    const expireInSeconds = environment.idleTimeoutInMinutes * 60;

    this.idle.setIdle(expireInSeconds - 60);

    this.idle.setTimeout(60);

    this.idle.onIdleEnd.subscribe(() => {
      console.log('No longer idle.');
    });

    this.idle.onIdleStart.subscribe(() => {
      console.log("Idle started");
    });


    this.idle.onTimeout.subscribe(() => {
      console.log(`User was idle for ${expireInSeconds / 60} minutes, session is timed out!`);
      this.securityService.manageUserSession(-1).then((result) => {
        if (result == -1) {
          this.StopWatch();
        } else {
          this.started = true;
          this.idle.setKeepaliveEnabled(true);
          this.idle.watch();
        }
      });
    });
    if (!this.started) {
      this.started = true;
      this.idle.setKeepaliveEnabled(true);
      this.idle.watch();
    }
  }

  StopWatch() {
    this.idle.stop();
    // Prevent idle lib to create multiple observers when the user logout and re-login again
    this.idle.onTimeout.observers.length = 0;
    this.idle.onIdleStart.observers.length = 0;
    this.idle.onIdleEnd.observers.length = 0;

    this.started = false;
  }

  IsStarted() {
    return this.started;
  }
  StartWatch() {
    //this is used in html editor to extented the timeout
    if (this.started) {
      this.started = true;
      this.idle.setKeepaliveEnabled(true);
      this.idle.watch();
      if (this.typeStarted == null) {
        this.typeStarted = new Date();
      }
      const diffTime = new Date().getMinutes() - this.typeStarted.getMinutes()
      if (diffTime == environment.idleTimeoutInMinutes - 2) {
        this.securityService.manageUserSession(1);
        this.typeStarted = new Date();
      }
    }
  }
}
